require('./message.scss');

// @ vendor
const React = require('react');

// @ helpers
const { formatText, FormattedText } = require('core/i18n').i18n;

// @ commons
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKLink } = require('commonsComponents/OKLink');

// @ components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

const buildCCMessage = () => {
    const {message, linkUrl, linkText} = getPoeKeys();
    return (
        <BlockInfo
            extraClass={'insurance-request-wizard-gdpr-message__block-info'}
        >
            <FormattedText value={message} />
            <OKLink
                modifier="emphasize"
                to={linkUrl}
            >
                <FormattedText value={linkText} />
            </OKLink>
        </BlockInfo>
    );
}

const buildMessage = () => {
    const {message, linkUrl, linkText} = getPoeKeys();
    return (
        <OKMessage
            type="informative"
        >
            <FormattedText value={message} />
            <OKLink
                modifier="emphasize"
                to={linkUrl}
            >
                <FormattedText value={linkText} />
            </OKLink>
        </OKMessage>
    );
}

const getPoeKeys = () => {
    const poeditorPrefix = 'mortgageRequestPanel';
    return {
        message : `${poeditorPrefix}-${poeditorPrefix}_propietorContent`,
        linkUrl : formatText(`${poeditorPrefix}-${poeditorPrefix}_propietorUrl`),
        linkText : `${poeditorPrefix}-${poeditorPrefix}_propietorUrlText`,
    }
}

const message = () => (
    __CONTACT_CENTER__ ? buildCCMessage() : buildMessage()
);
module.exports = message;
